import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { LanguageProvider } from '@/context/LanguageContext';
import LenisScroll from '@/components/LenisScroll';
import ErrorBoundary from '@/components/ErrorBoundary';
import ScrollToTop from '@/components/ScrollToTop';
import Navbar from '@/components/Navbar';
import WhatsAppButton from '@/components/WhatsAppButton';
import Hero from '@/components/Hero';
import Marquee from '@/components/Marquee';
import RatesSection from '@/components/RatesSection';
import HowItWorks from '@/components/HowItWorks';
import BentoFeatures from '@/components/BentoFeatures';
import ApplyFlow from '@/components/apply/ApplyFlow';
import FAQ from '@/components/FAQ';
import Footer from '@/components/Footer';
import TrackPage from '@/pages/TrackPage';
import AdminPage from '@/pages/AdminPage';

function Home() {
  return (
    <>
      <main>
        <Hero />
        <Marquee />
        <RatesSection />
        <HowItWorks />
        <BentoFeatures />
        <ApplyFlow />
        <FAQ />
      </main>
      <Footer />
      <WhatsAppButton />
    </>
  );
}

function Track() {
  return (
    <>
      <main className="min-h-screen pb-24 pt-28">
        <TrackPage />
      </main>
      <Footer />
      <WhatsAppButton />
    </>
  );
}

export default function App() {
  return (
    <div className="min-h-screen bg-ink text-slate-100">
      <BrowserRouter>
        <LanguageProvider>
          <LenisScroll />
          <ScrollToTop />
          <ErrorBoundary>
            <div className="grain" aria-hidden="true" />
            <Navbar />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/track" element={<Track />} />
              <Route path="/admin" element={<AdminPage />} />
              <Route path="*" element={<Home />} />
            </Routes>
          </ErrorBoundary>
        </LanguageProvider>
      </BrowserRouter>
    </div>
  );
}
